import type { CityConfig } from "../city-template/types";

export const wyomingConfig: CityConfig = {
  city: "Wyoming",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "wyoming",
  route: "/states/wyoming",
  title: "Emergency Passport Wyoming MI | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Wyoming, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Wyoming, Grandville, Byron Center, and all Kent County residents. Southwest Grand Rapids metro coverage. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Wyoming, MI",
  heroSubtitle: "Wyoming travelers — Kent County residents, Metro Health professionals, 28th Street corridor workers, and southwest Grand Rapids metro families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Kent County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20suburban%20West%20Michigan%20neighborhood%20with%20tree-lined%20streets%2C%20modern%20homes%2C%20green%20parks%2C%20and%20commercial%20retail%20corridor%20along%20a%20wide%20boulevard%2C%20warm%20summer%20afternoon%20light%2C%20clear%20blue%20sky%2C%20no%20text%20no%20people%2C%20peaceful%20residential%20community%20landscape%20photography&width=1800&height=700&seq=wyoming-hero-001&orientation=landscape",
  heroImageAlt: "Suburban Wyoming Michigan neighborhood with tree-lined streets and green parks near the Grand Rapids metro area",
  geoPosition: "42.9134;-85.7053",
  geoPlacename: "Wyoming, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "211 W. Fort St, Suite 1300, Detroit, MI 48226",
    distance: "Approximately 160 miles east of Wyoming — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Wyoming", zips: "49509, 49519" },
    { name: "Grand Rapids", zips: "49501, 49503, 49504, 49505, 49506, 49507, 49508, 49509, 49512, 49525, 49534, 49544" },
    { name: "Grandville", zips: "49418" },
    { name: "Byron Center", zips: "49315" },
    { name: "Kentwood", zips: "49508, 49512, 49546, 49518" },
    { name: "Walker", zips: "49534, 49544" },
    { name: "Jenison", zips: "49428" },
    { name: "Hudsonville", zips: "49426" },
    { name: "Cutlerville", zips: "49508, 49548" },
    { name: "Caledonia", zips: "49316" },
    { name: "Holland", zips: "49422, 49423, 49424" },
    { name: "Allendale", zips: "49401" },
    { name: "Zeeland", zips: "49464" },
    { name: "Comstock Park", zips: "49321" },
    { name: "Sparta", zips: "49345" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Kent County Expertise", desc: "Southwest Grand Rapids metro, Gerald R. Ford International Airport, and West Michigan travel support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Kent County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Grand Rapids, MI", route: "/cities/grand-rapids" },
    { name: "Emergency passport services in Kentwood, MI", route: "/cities/kentwood" },
    { name: "Urgent passport services in Holland, MI", route: "/cities/holland" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wyoming, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 160-mile drive or appointment wait. Wyoming residents can ship from any UPS or FedEx in Kent County.",
  fpcOfficeDistance: "Serving Wyoming, Grandville, Byron Center, Kentwood, Walker, and all of Kent County and the Grand Rapids metro area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Wyoming and the greater Kent County region. From the 28th Street corridor to Metro Health, from the Grandville border to Cutlerville — we serve all of southwest Grand Rapids metro. The Detroit Passport Agency is approximately 160 miles east, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Wyoming and all Kent County communities including Grandville, Byron Center, Kentwood, Walker, Jenison, Hudsonville, Cutlerville, Caledonia, and Comstock Park. We also serve West Michigan travelers and Gerald R. Ford International Airport flyers.",
  howItWorksIntro: "Most Wyoming travelers complete everything online and ship documents overnight. No driving 160 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Wyoming is a growing Kent County community with strong ties to Grand Rapids, Metro Health, and the 28th Street business corridor. Here are the most common passport mistakes we see from southwest Grand Rapids metro travelers.",
  testimonialsIntro: "Wyoming travelers — from Gerald R. Ford International Airport flyers to Metro Health professionals to 28th Street corridor workers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Wyoming, MI? Here are the most common ones we hear from Kent County and Grand Rapids metro travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 160-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for GRR Airport and Kent County travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Wyoming travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute Gerald R. Ford International Airport flights, family emergencies, and business travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "GRR Airport and Kent County travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Wyoming adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Kent County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Wyoming residents and families — including new citizens, college students, and Kent County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Wyoming residents who lost their passport before international travel or GRR Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Wyoming-area families planning international vacations, study abroad, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Wyoming and Kent County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Wyoming MI", description: "Urgent passport processing for Wyoming Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Wyoming MI", description: "Fast passport renewal for Wyoming Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Wyoming MI", description: "New passport application services for Wyoming Michigan residents applying for their first passport." },
    { name: "Child Passport Wyoming MI", description: "Minor passport services for Wyoming Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Wyoming, MI",
      rating: 5,
      text: "Business trip to Toronto in 3 days and my passport was expired. Fast Passport Center saved it — renewed in 2 days. I shipped from the UPS Store on 28th Street and had it back before my flight. No drive to Detroit.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah L.",
      location: "Grandville, MI",
      rating: 5,
      text: "My daughter's study abroad to Germany was in 5 days and her passport was lost. Fast Passport Center had a replacement in our hands in 36 hours. Their courier service is incredible for Kent County families.",
      service: "Lost Passport Replacement",
    },
    {
      name: "James T.",
      location: "Wyoming, MI",
      rating: 5,
      text: "First-time passport for a Caribbean cruise with 10 days notice. Fast Passport Center processed it in 5 days. They caught an error on my birth certificate copy that would have delayed me.",
      service: "First-Time Passport",
    },
    {
      name: "Karen W.",
      location: "Byron Center, MI",
      rating: 5,
      text: "Family vacation to Mexico and I realized my passport was expiring too soon. Fast Passport Center got me renewed in 3 days. Professional, fast, and worth every penny for the peace of mind.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "wyo-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "211 W. Fort St, Suite 1300",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 160 miles east of Wyoming — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "wyo-2",
      name: "Wyoming Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1850 28th St SW",
      city: "Wyoming",
      state: "MI",
      zip: "49519",
      phone: "(616) 538-5320",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Wyoming — on the 28th Street corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Wyoming acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to 28th Street corridor and southwest Grand Rapids metro residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wyo-3",
      name: "Grand Rapids Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "600 Fountain St SE",
      city: "Grand Rapids",
      state: "MI",
      zip: "49503",
      phone: "(616) 458-3351",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Grand Rapids — approximately 5 miles northeast of Wyoming",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Grand Rapids and northern Wyoming residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "wyo-4",
      name: "Grandville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3015 44th St SW",
      city: "Grandville",
      state: "MI",
      zip: "49418",
      phone: "(616) 531-4040",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Grandville — approximately 3 miles west of Wyoming",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Grandville and western Wyoming residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "wyo-5",
      name: "Kentwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3660 29th St SE",
      city: "Kentwood",
      state: "MI",
      zip: "49512",
      phone: "(616) 949-9610",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kentwood — approximately 6 miles east of Wyoming",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kentwood and eastern Wyoming residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Kent County" },
    { feature: "GRR Airport & Kent County Expertise", agency: "No tailored advice", fpc: "Yes — Gerald R. Ford International Airport and Kent County travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Wyoming and Kent County travelers often discover passport issues right before GRR Airport departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some southwest Grand Rapids metro travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Kent County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Gerald R. Ford International Airport Flight Requirements",
      description: "Gerald R. Ford International Airport (GRR) in Grand Rapids has growing international flight options. Many Wyoming travelers also use Chicago O'Hare or Detroit Metro. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Kent County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Wyoming, Grand Rapids, or Kentwood." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 160-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kent County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Wyoming, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Wyoming, located at 211 W. Fort St, Suite 1300, Detroit, MI 48226 — approximately 160 miles east. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Wyoming?", a: "Fast Passport Center offers emergency passport processing in Wyoming, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 160 miles east or take a day off work." },
    { q: "Do I need a passport for international flights from Gerald R. Ford International Airport?", a: "Yes. All international flights from Gerald R. Ford International Airport (GRR) in Grand Rapids require a passport book. GRR serves Wyoming and all of Kent County. While GRR has growing international options, many Wyoming travelers also connect through Chicago O'Hare or Detroit Metro for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Wyoming suburbs like Grandville or Byron Center?", a: "Absolutely. Fast Passport Center serves all of Kent County including Grandville, Byron Center, Kentwood, Walker, Jenison, Hudsonville, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Wyoming-area travelers use for international flights?", a: "Gerald R. Ford International Airport (GRR) in Grand Rapids is the primary airport for Wyoming and Kent County — approximately 5–10 miles northeast. GRR has growing domestic and international service. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international hub — approximately 160 miles east. Many Wyoming travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Wyoming, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Wyoming-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Wyoming, Grand Rapids, and Kentwood offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Wyoming?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Wyoming", address: "1800 28th St SW, Wyoming, MI 49519", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Wyoming", address: "1910 28th St SW, Wyoming, MI 49519", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Grand Rapids", address: "1000 E Beltline Ave NE, Grand Rapids, MI 49525", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Grandville", address: "4115 Canal Ave SW, Grandville, MI 49418", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Wyoming", address: "3355 28th St SW, Wyoming, MI 49519", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Wyoming, Grandville, and southwest Kent County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Grand Rapids", address: "3777 3 Mile Rd NW, Grand Rapids, MI 49544", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Grand Rapids, Walker, and northern Kent County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "GRR",
      name: "Gerald R. Ford International Airport",
      distance: "Located in Grand Rapids — approximately 5–10 miles northeast of Wyoming",
      address: "5500 44th St SE, Grand Rapids, MI 49512",
      note: "Primary airport for Wyoming and Kent County. Growing domestic and international service. Southwest, Delta, American, United, and Allegiant service. International flights to Cancun and Toronto available seasonally. Most Wyoming international travelers connect through DTW or Chicago O'Hare.",
      flightUrl: "https://www.grr.org/",
      flightLabel: "GRR Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 160 miles east of Wyoming via I-96",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for West Michigan. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Wyoming international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};